export default __webpack_public_path__ + "static/media/10.d38f4011.jpg";